const imsClientIds = {
  test: process.env.REACT_APP_IMS_TEST_CLIENT,
  stage: process.env.REACT_APP_IMS_STAGE_CLIENT,
  prod: process.env.REACT_APP_IMS_PROD_CLIENT,
}

const imsRedirectUris = {
  test: process.env.REACT_APP_IMS_TEST_REDIRECT_URI,
  stage: process.env.REACT_APP_IMS_STAGE_REDIRECT_URI,
  prod: process.env.REACT_APP_IMS_PROD_REDIRECT_URI,
}

const getEnvironment = () => {
  const host = window.location.hostname
  if (host === 'localhost') {
    return host
  } else {
    // eslint-disable-next-line
    const [_, environment] = host.match(/[^.]*-([^\.]*)\..*/i) || []
    return environment || 'prod'
  }
}

const isDevelopmentEnv = getEnvironment() === 'localhost' || getEnvironment() === 'development'
const isTestEnv = getEnvironment() === 'test'
const isStageEnv = getEnvironment() === 'stage'
const isProductionEnv = getEnvironment() === 'prod'

const getImsRedirectUrl = () => {
  const environment = getEnvironment()
  const clientId = imsClientIds[environment] || imsClientIds.prod
  const redirectUri = imsRedirectUris[environment] || imsRedirectUris.prod

  const { pathname = '', search = '' } = window.location
  const originalPath = encodeURIComponent(pathname + search)
  const state = JSON.stringify({ originalPath })
  return `${process.env.REACT_APP_IMS_INSTANCE}/ims/authorize/v1?client_id=${clientId}&redirect_uri=${redirectUri}&scope=AdobeID,openid,read_organizations,read_pc&response_type=code&state=${state}`
}

const getAuthRedirectUrl = () => {
  return getImsRedirectUrl()
}

const devToken = process.env.REACT_APP_DEV_TOKEN
const API_AUTH_OPTIONS = devToken
  ? {
      headers: {
        'x-access-token': devToken,
        'Access-Control-Allow-Origin': '*',
      },
    }
  : { credentials: 'include' }

const getReportSuiteType = () => {
  return isProductionEnv ? 'prod' : 'test'
}

export {
  getEnvironment,
  getAuthRedirectUrl,
  getReportSuiteType,
  isDevelopmentEnv,
  isTestEnv,
  isStageEnv,
  isProductionEnv,
  API_AUTH_OPTIONS,
}
